import { Outlet } from 'react-router-dom';

import { DayModeAtmosphereProvider } from '../context/DayModeAtmosphere';
import { useDayModeAtmosphere } from '../context/useDayModeAtmosphere';
import { BottomNavigation } from './BottomNavigation';

function AppShellContent() {
  const { dayMode } = useDayModeAtmosphere();
  return (
    <div className="app-shell" data-day-mode={dayMode}>
      <Outlet />
      <BottomNavigation />
    </div>
  );
}

export function AppShell() {
  return (
    <DayModeAtmosphereProvider>
      <AppShellContent />
    </DayModeAtmosphereProvider>
  );
}
